'use client';

import { createContext, useContext } from 'react';

// Defaults to `true` so consumers rendered outside an AltenarFrame keep relying on the SDK global being present.
const AltenarSDKContext = createContext<boolean>(true);

const AltenarSDKProvider = AltenarSDKContext.Provider;

/**
 * Whether the Altenar SDK script has finished loading (set by AltenarFrame).
 */
function useAltenarSDKLoaded(): boolean {
  return useContext(AltenarSDKContext);
}

export { AltenarSDKProvider, useAltenarSDKLoaded };
